import { SVGIcon } from '../Icons'
import { ISVGProps } from '../types'

const Bed = (props: ISVGProps) => (
  <SVGIcon {...props}>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5001 8.98329V6.66663C17.5001 5.29163 16.3751 4.16663 15.0001 4.16663H11.6667C11.0251 4.16663 10.4417 4.41663 10.0001 4.81663C9.55841 4.41663 8.97508 4.16663 8.33342 4.16663H5.00008C3.62508 4.16663 2.50008 5.29163 2.50008 6.66663V8.98329C1.99175 9.44163 1.66675 10.1 1.66675 10.8333V15.8333H3.33341V14.1666H16.6667V15.8333H18.3334V10.8333C18.3334 10.1 18.0084 9.44163 17.5001 8.98329ZM11.6667 5.83329H15.0001C15.4584 5.83329 15.8334 6.20829 15.8334 6.66663V8.33329H10.8334V6.66663C10.8334 6.20829 11.2084 5.83329 11.6667 5.83329ZM4.16675 6.66663C4.16675 6.20829 4.54175 5.83329 5.00008 5.83329H8.33342C8.79175 5.83329 9.16675 6.20829 9.16675 6.66663V8.33329H4.16675V6.66663ZM3.33341 12.5V10.8333C3.33341 10.375 3.70841 9.99996 4.16675 9.99996H15.8334C16.2917 9.99996 16.6667 10.375 16.6667 10.8333V12.5H3.33341Z"
        fill="#222222"
      />
    </svg>
  </SVGIcon>
)

export default Bed
